import type { JSX, MouseEvent } from 'react';

import { Color } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';

import * as Styles from './WarningAlertDescription.styles';

interface WarningAlertDescriptionProps {
  text: string | JSX.Element | null;
  onClick?: () => void;
  className?: string;
  testId?: string;
}

export const WarningAlertDescription = ({ text, onClick, testId, className = '' }: WarningAlertDescriptionProps) => {
  const _onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      event.stopPropagation();
      onClick();
    }
  };

  return (
    <div className={Styles.description.concat(' ' + className).trim()}>
      <div>
        <MTypography variant='body1' color={Color.Orange7} className={Styles.text} testId={testId} inline>
          {text}
        </MTypography>
        {onClick && (
          <a className={Styles.viewMoreButton} onClick={_onClick}>
            [View More]
          </a>
        )}
      </div>
    </div>
  );
};
